import {IABTestConfiguration} from "@pg-mono/ab-testing";

import {dsaRatingSortAbTest} from "./dsa_rating_sort_ab_test";
import {favouritesTopbarAbTest} from "./favourites_topbar_ab_test";
import {propertyFaqAbTest} from "./property_faq_ab_test";
import {unlockChoiceAbTest} from "./unlock_choice_ab_test";
import {uspListingTileAbTest} from "./usp_listing_tile_ab_test";

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: ["control", "treatment"], // Named variants, first one is default/control
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    uspListingTileAbTest,
    propertyFaqAbTest,
    dsaRatingSortAbTest,
    unlockChoiceAbTest,
    favouritesTopbarAbTest
];
import {IABTestConfiguration} from "@pg-mono/ab-testing";

import {dsaRatingSortAbTest} from "./dsa_rating_sort_ab_test";
import {favouritesTopbarAbTest} from "./favourites_topbar_ab_test";
import {propertyFaqAbTest} from "./property_faq_ab_test";
import {unlockChoiceAbTest} from "./unlock_choice_ab_test";
import {uspListingTileAbTest} from "./usp_listing_tile_ab_test";

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: ["control", "treatment"], // Named variants, first one is default/control
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    uspListingTileAbTest,
    propertyFaqAbTest,
    dsaRatingSortAbTest,
    unlockChoiceAbTest,
    favouritesTopbarAbTest
];
